import { Collapse } from "@material-ui/core";
import styles from "./ListItemProductArcTag.module.scss";
import { useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import default_image from "../../../assets/images/default_product.png";
import zoneIcon from "assets/images/zone-icon.svg";
import { capitalize } from "helpers/utils/utils_general";
import i18n from "i18n";

const ListItemProductTag = ({ tag, epcsOriginDestination = [], isCollapsable = false }) => {
  const [open, setOpen] = useState(!isCollapsable);

  const handleClick = () => {
    if(isCollapsable) setOpen(!open);
  };

  return (
    <article index={tag.product?.sku} className={isCollapsable ? styles["main-list-collapsable"] : styles["main-list"]}>
      <div onClick={handleClick} className={styles["button-list"]}>
        <div>
          <img
            src={tag.product?.image ? tag.product?.image : [default_image]}
            className={styles["image"]}
          />
          <div className={styles["detail"]}>
            <h4>{tag.product?.name}</h4>
            <p>{i18n.t("sku").toUpperCase()} {tag.product?.sku}</p>
          </div>
        </div>
        <div>
          {isCollapsable && (open ? <ExpandLess /> : <ExpandMore />)}
          <p className={styles["epc-count"]}>
            Tags <span>{tag.epcs.length}</span>
          </p>
        </div>
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ul className={styles["ListItemProductTag_list-epcs"]}>
          {tag?.epcs?.map(tag => {
             let origin = '';
             let destination = '';
             if(epcsOriginDestination.length > 0) {
               const epc = epcsOriginDestination?.find(epc => epc?.epc === tag);
               if(epc) {
                 origin = epc.origin_path_name || '-';
                 origin += origin?.origin_node ? ' (' + origin?.origin_node +')' : '';
                 destination = epc.destination_path_name || '';
               }
             }

            return (
            <li>
              <h3>{tag}</h3>
              <div>
                <span>
                  <img src={zoneIcon} alt="Icono de ubicación" />
                  <p>{capitalize(i18n.t("origin"))}</p>
                  <h5>{origin}</h5>
                </span>
                <span>
                  <img src={zoneIcon} alt="Icono de ubicación" />
                  <p>{capitalize(i18n.t("destination"))}</p>
                  <h5>{destination}</h5>
                </span>
              </div>
            </li>
          )})}
        </ul>
      </Collapse>
    </article>
  );
};

export default ListItemProductTag;
